var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "c-table-cell",
      style: _vm.backgroundColor,
      on: {
        click: function ($event) {
          _vm.displayCandidateStatusModal = true
        },
      },
    },
    [
      _c("m-candidate-status", {
        attrs: {
          active: _vm.displayCandidateStatusModal,
          "candidate-id": _vm.data.candidateId,
        },
        on: {
          close: function ($event) {
            _vm.displayCandidateStatusModal = false
          },
        },
      }),
      _c(
        "div",
        { staticClass: "c-table__cell-value" },
        [
          _c("div", [_vm._v(_vm._s(_vm.data.value))]),
          _vm.data.candidateStatus.date
            ? _c("div", { staticClass: "status-date" }, [
                _vm._v("(" + _vm._s(_vm.data.candidateStatus.date) + ")"),
              ])
            : _vm._e(),
          _vm.data.candidateStatus.scheduledDate
            ? _c("candidates-scheduled-date", {
                attrs: {
                  "status-id": _vm.data.candidateStatus.value,
                  date: _vm.data.candidateStatus.scheduledDate,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }